// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"733debf6","341":"733debf6","478":"733debf6","790":"733debf6","934":"733debf6","937":"733debf6"}[chunkId] + ".chunk.css";
};